<template>
  <div class="">
    <!-- {{report}} -->
    <table>
      <thead>
        <tr class="header-of-page">
          <div class=" p-3">

            <div class="center">
              <div class="row pb-1">
                <div class="title name">
                  <span v-if="customer.isCustomer">كشف حساب العميل :</span>
                  <span v-else>كشف حساب المورد :</span>
                  {{ customer.name }}
                </div>
              </div>
              <div class="row pb-1">
                <div v-if="dateRange" class="col-10 data-range title name">
                  <p>
                    <span>الحساب من تاريخ : </span>
                    <span>{{ dateRange[0] }}</span>
                  </p>
                  <p>
                    <span>الي تاريخ : </span>
                    <span>{{ dateRange[1] }}</span>
                  </p>
                </div>
                <div v-else class="col-10 title name">
                  {{ currentdate | moment("dddd | Do / MM / YYYY | h:mm A") }}
                </div>
              </div>
            </div>
          </div>
        </tr>
      </thead>

      <tbody class="bg-w" v-if="report != null">
        <tr>
          <table class="table" v-if="report != null">
            <colgroup>
              <col name="el-table_3_column_12" width="5%" />
              <col name="el-table_3_column_13" width="10%" />
              <col name="el-table_3_column_14" width="35%" />
              <col name="el-table_3_column_15" width="10%" />
              <col name="el-table_3_column_16" width="10%" />
              <col name="el-table_3_column_17" width="10%" />
              <col name="el-table_3_column_18" width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf"
                >
                  <div class="pr-1">السند</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_13 is-leaf"
                >
                  <div class="pr-1">التوقيت</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_14 is-leaf"
                >
                  <div class="text-center">بيان</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_15 is-leaf"
                >
                  <div class="text-center">مدين</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_16 is-leaf"
                >
                  <div class="text-center">دائن</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_17 is-leaf"
                >
                  <div class="text-center">الرصيد</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_18 is-leaf"
                >
                  <div class="text-center">بواسطة</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="" v-for="(item, index) in report" :key="index">
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.operation_id }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf"
                >
                  {{ item.created_at | moment("Do / MM / YYYY") }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_13 is-leaf text-center"
                >
                  <div class="bg-Lightgray align-center">
                    {{ item.description }}
                  </div>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_14 is-leaf text-center"
                  style="text-align: center"
                >
                  <span v-if="item.type === 1">{{ item.amount }}</span>
                  <span v-else></span>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_15 is-leaf text-center"
                  style="text-align: center"
                >
                  <span v-if="item.type === 0">{{ item.amount }}</span>
                  <span v-else></span>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_16 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.account }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_16 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.user.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";
// window.ipcRenderer = ipcRenderer;
export default {
  props: ["report", "customer", "dateRange", "img"],

  data() {
    return {
      currentdate: new Date(),
    };
  },
  methods: {
    numberToFixed(number) {
      let num = Number(number);
      return Math.floor(num * 100) / 100;
    },
  },

  mounted() {
    // this.invoiceDetails = JSON.parse(localStorage.getItem("sale_invoice"));
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_color.scss";
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Open+Sans:wght@400;600;700&display=swap");
body {
  font-family: cairo !important;
}
.bg-w {
  margin: 0;

  padding: 0;
}
.header-of-page {
  background-color: #f7f8fa;

  .p-3 {
    padding: 22px 18px !important;
  }
  .logo {
    width: 18%;
    .img-fluid {
      width: 56px;
      height: 56px;
    }
  }
  .center {
    .logo {
      height: 47px;
      width: 75px;
    }
  }
  .content {
    width: 50%;
    .title {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 0;
    }
  }
  .border {
    width: 100%;
    padding: 13px 8px;
    border-top: 2px solid #fff;
    .first,
    .second {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;

      margin-left: 22px;
      .icon {
        font-size: 7px;
        color: #d8d8d8;
      }
      P {
        text-align: center !important;
        width: 96%;
      }
    }
    .first {
      width: 45%;
    }
    .second {
      width: 35%;
    }
    .third {
      width: 25%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;

      .icon {
        font-size: 4px;
        color: #d8d8d8;
      }
    }
  }
}
.bg-whi {
  width: 100%;
  height: 21vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .firstDiv {
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    width: 95%;
    height: 19vh;

    .thead {
      background-color: #f2f3f5;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
    }
    .tbody {
      background-color: $subColor;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 12px;
      font-weight: bold;
    }
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.footer-of-page {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 28px;

  background: #f7f8fa;
  p {
    font-family: Cairo;
    font-size: 8px;
  }
}
table {
  width: 100%;
  border: none;
  caption-side: bottom;
  thead tr {
    border: none !important;
  }
  tr {
    border: none !important;
  }
}
.table {
  margin: 1rem auto;
  width: 95%;
  border: none;
  border-collapse: collapse;
  border-bottom: none !important;
  font-size: 13px !important;
  thead {
    padding: 10px;

    border: none;
    tr {
      th {
        padding: 7px;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          color: #000000;
          font-family: Cairo;
          font-size: 12px !important;
          font-weight: 600;
          display: flex;
        }
      }
    }
  }
  tbody {
    border: none;
    tr {
      td {
        text-align: right;
        padding: 3px;
        margin-bottom: 0.5rem;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          height: 70px;
          color: #000000;
          font-family: Cairo;
          font-size: 10px;
          font-weight: 600;
          display: flex !important;

          &.bg-gray {
            background-color: #e5e5e5;
          }
          &.bg-Lightgray {
            background-color: #f7f8fa;
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  tfoot {
    td {
      border: 1px solid #000 !important;
    }
  }

  tr,
  td {
    border: none;
    line-height: 1.7;
    text-align: right;
  }
  tfoot {
    border: none;
    tr {
      height: 30px;
      border: none;
    }
  }
}
.pb-2 {
  padding-bottom: 1rem;
}
.text-center {
  text-align: center;
}
.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans" !important;
}
.d-none {
  display: none;
}
.mt {
  margin-top: 182px;
}
.onlyAlign {
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
}
.pb-1 {
  margin-bottom: 0.5rem;
}
.mr-auto {
  margin-right: auto;
}
.pr-1 {
  padding-right: 0.5rem;
}
.d-flex {
  display: flex !important;
}
.paymentDitals {
  border-collapse: collapse;
  background-color: white;

  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.total-qty {
  border-collapse: collapse;
  background-color: white;
  margin-right: auto;

  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.data-range {
  display: flex !important;
  p {
    margin-right: 10px;
    margin-left: 10px;
  }
  p:first-child {
    margin-right: 0;
  }
}
</style>
